import { Outlet } from "react-router-dom";

/**
 * Minimal container for embeddable pages
 * Does not include auth, sidebar, or other app shell components
 * Designed for iframe embedding on external websites
 */
export const Embed = () => {
  return <Outlet />;
};
